passwordConfirmation();

function passwordConfirmation() {
    const password = document.querySelector('.js-password');
    const passwordConfirmation = document.querySelector('.js-password-confirmation');
    const submit = document.querySelector('.js-submit');

    if (!password || !passwordConfirmation || !submit) {
        return;
    }

    passwordConfirmation.addEventListener('input', () => {
        if (password.value === passwordConfirmation.value) {
            passwordConfirmation.setCustomValidity('');
        } else {
            passwordConfirmation.setCustomValidity('Passwords do not match');
        }

        passwordConfirmation.reportValidity();
    });

    submit.addEventListener('click', () => {
        if (password.value === passwordConfirmation.value) {
            passwordConfirmation.setCustomValidity('');
        } else {
            passwordConfirmation.setCustomValidity('Passwords do not match');
        }

        passwordConfirmation.reportValidity();
    });
}

function accountWelcomeBanner() {
    const banner = document.querySelector('.js-account-welcome');

    if (banner) {
        // When a close link is clicked:
        // – Hide the banner
        // – Create a cookie for that banner using messageid data attr
        document.querySelectorAll('.js-account-welcome-close').forEach(el => {
            el.addEventListener('click', e => {
                e.preventDefault();

                var d = new Date();

                // Hide this banner
                banner.classList.add('hidden');

                // Create a cookie for this banner to expire 2 months from now
                d.setTime(d.getTime() + 60 * 24 * 60 * 60 * 1000);

                document.cookie = el.dataset.id + '=true; expires=' + d.toUTCString() + '; path=/';
            });
        });
    }
}

accountWelcomeBanner();
